var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_3725)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5855 0H155.443C166.26 0 175.029 8.76875 175.029 19.5855V155.443C175.029 166.26 166.26 175.029 155.443 175.029H19.5855C8.76875 175.029 0 166.26 0 155.443V19.5855C0 8.76875 8.76875 0 19.5855 0Z",
    fill: "#0083CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8511 102.831V132.743H60.083V43.2668H91.639C97.9559 43.2668 103.35 44.0168 107.878 45.5167C112.407 47.0166 116.128 49.0646 119.041 51.6895C121.955 54.3143 124.118 57.4007 125.531 60.9486C126.916 64.4964 127.608 68.3616 127.608 72.4864C127.608 76.9573 126.887 81.0532 125.474 84.7742C124.031 88.4951 121.839 91.6969 118.897 94.3506C115.955 97.0043 112.205 99.0811 107.677 100.581C103.148 102.081 97.8117 102.831 91.6101 102.831H80.7934H80.8511ZM80.8511 87.1683H91.6678C97.0617 87.1683 100.956 85.8703 103.321 83.3031C105.686 80.7359 106.869 77.1304 106.869 72.4864C106.869 70.4384 106.552 68.5635 105.946 66.8906C105.34 65.2176 104.388 63.7753 103.148 62.5639C101.908 61.3524 100.321 60.4294 98.4174 59.7659C96.5137 59.1025 94.2638 58.7852 91.639 58.7852H80.8223V87.1683H80.8511Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5856 3.4613C13.3552 3.4613 8.01897 7.03803 5.33643 12.2012C16.1531 26.8831 48.8629 75.1401 87.5146 75.1401C126.166 75.1401 158.847 26.8831 169.693 12.2012C167.01 7.03803 161.674 3.4613 155.444 3.4613H19.5856Z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5856 171.337C13.3552 171.337 8.01897 167.76 5.33643 162.597C16.1531 147.915 48.8629 148.261 87.5146 148.261C126.166 148.261 158.876 147.915 169.693 162.597C167.01 167.76 161.674 171.337 155.444 171.337H19.5856Z",
    fill: "#F2F2F2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.443 166.347H19.5854C13.5569 166.347 8.65332 161.443 8.65332 155.414V19.5854C8.65332 13.5569 13.5569 8.65332 19.5854 8.65332H155.443C161.472 8.65332 166.375 13.5569 166.375 19.5854V155.443C166.375 161.472 161.472 166.375 155.443 166.375V166.347ZM19.5854 12.1147C15.4606 12.1147 12.1147 15.4606 12.1147 19.5854V155.443C12.1147 159.568 15.4606 162.914 19.5854 162.914H155.443C159.539 162.914 162.885 159.568 162.885 155.443V19.5854C162.885 15.4606 159.539 12.1147 155.443 12.1147H19.5854Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_3725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingActive);
export default __webpack_public_path__ + "static/media/parking_active.c70ebe8309fd2929bdeb651c5ceee15b.svg";
export { ForwardRef as ReactComponent };